import { useCallback } from 'react';
import { useGetMediaSourceVariant } from 'features/media';

type P = {
  size?: string;
  userId: string;
};

export const useGetNodeUserAvatar = () => {
  const getMediaSource = useGetMediaSourceVariant();

  return useCallback(
    ({ size = 'medium', userId }: P): string => getMediaSource({ id: userId, size, type: 'user_avatar' }),
    [getMediaSource],
  );
};
